/* punchline text scroll effect */
document.addEventListener('DOMContentLoaded', function () {
  function wrapWordsInSpan() {
    const textElement = document.querySelector('.home__punchline .cell');
    if (!textElement) return;
  
    const text = textElement.textContent.trim();
    const words = text.split(' ').map((word) => `<span class="word">${word} </span>`).join(' ');
  
    textElement.innerHTML = words;
  }
  
  wrapWordsInSpan();
  
  const words = document.querySelectorAll('.home__punchline .word');

  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  function interpolateColor(color1, color2, t) {
    const c1 = color1.match(/\w\w/g).map((x) => parseInt(x, 16));
    const c2 = color2.match(/\w\w/g).map((x) => parseInt(x, 16));
    
    const r = Math.round(lerp(c1[0], c2[0], t));
    const g = Math.round(lerp(c1[1], c2[1], t));
    const b = Math.round(lerp(c1[2], c2[2], t));
    
    return `rgb(${r}, ${g}, ${b})`;
  }
  
  function updateColor() {
    const viewportHeight = window.innerHeight;
  
    words.forEach((word) => {
      const rect = word.getBoundingClientRect();
      const progress = Math.min(Math.max((viewportHeight - rect.top) / viewportHeight, 0), 1);

      const startColor = "#1b1b1c";
      const endColor   = "#7D54E8";
  
      word.style.color = interpolateColor(startColor, endColor, progress);
    });
  }
  
  window.addEventListener('scroll', updateColor);
  updateColor();
});


